import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangas';
import { useState } from 'react';

export default function CategorySection() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const displayCategories = categories.filter((c) => c.id !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="category-section-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 id="category-section-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2">九大分类，覆盖所有你喜欢的漫画题材</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?type=${cat.id}`}
              className="group relative bg-background-50 rounded-xl p-5 md:p-6 transition-all duration-300 hover:bg-primary-500 overflow-hidden"
              onMouseEnter={() => setHoveredId(cat.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full mb-4 transition-all duration-300 ${
                hoveredId === cat.id ? 'bg-background-50/20' : 'bg-primary-100'
              }`}>
                <i className={`${cat.icon} text-xl md:text-2xl ${
                  hoveredId === cat.id ? 'text-background-50' : 'text-primary-600'
                } transition-colors duration-300`}></i>
              </div>
              <h3 className={`font-heading text-lg font-semibold mb-1.5 transition-colors duration-300 ${
                hoveredId === cat.id ? 'text-background-50' : 'text-foreground-900'
              }`}>
                {cat.name}
              </h3>
              <p className={`text-xs md:text-sm transition-colors duration-300 ${
                hoveredId === cat.id ? 'text-background-50/80' : 'text-foreground-500'
              }`}>
                {cat.description}
              </p>
              <div className={`mt-3 flex items-center gap-1 text-xs font-medium transition-all duration-300 ${
                hoveredId === cat.id ? 'text-background-50 opacity-100 translate-x-0' : 'text-primary-500 opacity-0 -translate-x-2'
              }`}>
                浏览漫画
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}